import { render, staticRenderFns } from "./ReplaceBoxModal.vue?vue&type=template&id=708aeffd&scoped=true&"
import script from "./ReplaceBoxModal.vue?vue&type=script&lang=js&"
export * from "./ReplaceBoxModal.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceBoxModal.vue?vue&type=style&index=0&id=708aeffd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708aeffd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VForm,VImg,VTextField})
